import PageShell from './PageShell';
import PrivacyPolicy from './PrivacyPolicy';
import Disclaimer from './Disclaimer';

export default function LegalPage({ kind }: { kind: 'privacy' | 'disclaimer' }) {
  return <PageShell>{kind === 'privacy' ? <PrivacyPolicy /> : <Disclaimer />}</PageShell>;
}
